<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>

    <div v-else>
      <vx-card>
        <vs-table
          :max-items="descriptionItems[0]"
          pagination
          :data="teamMappings"
          description
          search
          @selected="openView"
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("setup.label.TeamMapping") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push({ name: 'Create Team Mapping' })"
                size="small"
                >{{ $t("setup.label.CreateTeamMapping") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("setup.label.CityName") }}</vs-th>
            <vs-th>{{ $t("setup.label.Category") }}</vs-th>
            <vs-th>{{ $t("setup.label.Subcategory") }}</vs-th>
            <vs-th>{{ $t("setup.label.TeamCode") }}</vs-th>
            <vs-th>{{ $t("setup.label.TeamHead") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="teamMapping"
              v-for="(teamMapping, index) in data"
            >
              <vs-td :data="teamMapping.cityName">{{
                teamMapping.cityName
              }}</vs-td>
              <vs-td :data="teamMapping.categoryId">{{
                teamMapping.category
              }}</vs-td>
              <vs-td :data="teamMapping.subcategoryId">{{
                teamMapping.subcategory
              }}</vs-td>
              <vs-td :data="teamMapping.teamId">{{
                teamMapping.teamCode
              }}</vs-td>
              <vs-td :data="teamMapping.userId">{{
                teamMapping.username
              }}</vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EyeIcon"
                    :title="$t('setup.label.View')"
                    svgClasses="w-5 h-5 stroke-current cursor text-primary"
                    @click.stop="openView(teamMapping)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('setup.label.Edit')"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="editData(teamMapping.id)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    :title="$t('setup.label.Delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      deleteItemPopup = true;
                      delId = teamMapping.id;
                    "
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('setup.label.Delete') + ' ' + $t('setup.label.TeamMapping')"
          :active.sync="deleteItemPopup"
          class="popup-close small-popup"
        >
          <div class="center">
            <img src="@/assets/images/pages/delete.svg" />
            <div class="success-msg">
              {{ $t("system.label.areYouSureDelete") }}
            </div>
          </div>

          <div class="center">
            <span class="p-2">
              <vs-button type="border" @click="deleteItemPopup = false">{{
                $t("system.label.cancel")
              }}</vs-button></span
            >

            <span class="p-2">
              <vs-button @click="removeTeamMapping(delId)">{{
                $t("setup.label.Ok")
              }}</vs-button>
            </span>
          </div>
          <div style="height: 20px"></div>
        </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      descriptionItems: [5, 10, 15],
      deleteItemPopup: false,
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      teamMappings: (state) => state.teamMapping.teamMappings,
    }),
  },
  methods: {
    async getMappingList() {
      this.loading = true;
      try {
        await this.$store.dispatch("teamMapping/fetchTeamMappingList");
      } catch (e) {
        this.$toasted.error(e.message);
      }
      this.loading = false;
    },
    editData(id) {
      this.$router.push({ name: "Edit Team Mapping", params: { id: id } });
    },
    openView(teamMappings) {
      this.$router.push({
        name: "View Team Mapping",
        params: { id: teamMappings.id },
      });
    },
    async removeTeamMapping(id) {
      try {
        await this.$store.dispatch("teamMapping/deleteTeamMappingAction", id);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Team Mapping Successfully Deleted",
          type: "success",
        });
        this.deleteItemPopup = false;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
  },
  mounted() {
    this.getMappingList();
  },
};
</script>

<style lang="scss"></style>
